import { Alert } from '@tribeplatform/react-ui-kit/Alert';
export const AlertBlock = Alert;
//# sourceMappingURL=Block.js.map